export const showModal = {
  methods: {
    showModal (i, p) {
      this.$store.dispatch('VIEW_SHOWMODAL', true)
      this.$store.dispatch('VIEW_MODALCONTENT', i)
      this.$store.dispatch('VIEW_MODALPROPS', p)
      this.$store.state.showModal ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    }
  }
}

export const closeModal = {
  methods: {
    closeModal () {
      this.$store.dispatch('VIEW_SHOWMODAL', false)
      this.$store.dispatch('VIEW_MODALCONTENT', false)
      this.$store.dispatch('VIEW_MODALPROPS', false)
      document.body.classList.remove('body-stop')
    }
  }
}

export const scrollNav = {
  methods: {
    onScrollInNav () {
      this.$store.dispatch('VIEW_NAV', true)
    },
    onScrollOutNav () {
      this.$store.dispatch('VIEW_NAV', false)
    }
  }
}

export const showTab = {
  data () {
    return {
      tab: 1
    }
  },
  methods: {
    showTab (i) {
      this.tab = i
    }
  }
}

export const showAccordion = {
  data () {
    return {
      accordion: false
    }
  },
  methods: {
    showAccordion (i) {
      this.accordion === i ? this.accordion = false : this.accordion = i
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins.js